// Expose Core API globally
import "./exports/index";

import "react-loading-skeleton/dist/skeleton.css";

// Import global SCSS
import "../scss/style.scss";

// Import Consent Manager BEFORE anything else that might need it
import "./common/features/cookieConsent/ConsentManager";

// --- GSAP Animation Engine ---
import { initScrollAnimations } from "./common/animation/scrollAnimations";

import "./app/i18n";

// Import and initialize Quicklink
import { listen } from "quicklink";

// Import store to ensure it's initialized
import { store } from "./app/store";

// Import hydration system
import { hydrateComponents } from "./app/hydrate";

// Import the url sync helper
import { syncLanguageToUrl } from "./common/helpers/syncLanguageToUrl";

// Header Logic
import { initDefaultTopBarSwiper } from "./parts/header/topBarDefault";
import { initNocTopBarSwiper } from "./parts/header/topBarNoc";
import { initNocStickyHeader } from "./parts/header/stickyHeaderNoc";
import { initStickyHeaderEmu } from "./parts/header/stickyHeaderEmu";
import { initMobileMenuOffcanvas } from "./parts/header/mobileMenu"; // Shared logic

// ==========================================
// NOC DESIGN SYSTEM: PAGE COMPONENTS
// ==========================================
import { initArchiveMasonry } from "./partials/PageContent/noc/archiveMasonry";
import { initHeroSlider } from "./partials/PageContent/noc/heroSlider";
import { initHeroBento } from "./partials/PageContent/noc/heroBento";
import { initCtaSlider } from "./partials/PageContent/noc/ctaSlider";
import { initCtaImageParallax } from "./partials/PageContent/noc/ctaImage";
import { initCategoriesSlider } from "./partials/PageContent/noc/categoriesSlider";
import { initArchiveShowcaseVideos } from "./partials/PageContent/noc/archiveShowcase";
import { initArticleWSlider } from "./partials/PageContent/noc/articleWSlider";
import { initEmuHomeCarousel } from "./partials/PageContent/emu/homeCarousel";
import { initFastAutoSlider } from "./partials/PageContent/fast/autoSlider";

// Post Components
import { initVideoFacades } from "./partials/PostContent/noc/video";
import { initGalleries } from "./partials/PostContent/noc/gallery";
import { initAccordions } from "./partials/PostContent/noc/accordion";

// Initialize Global Logic
const initGlobals = () => {
  // Run the URL sync logic first
  syncLanguageToUrl();

  // Initialize Scroll Animations (GSAP)
  initScrollAnimations();

  // Header Initialization
  initDefaultTopBarSwiper();
  initNocTopBarSwiper();
  initNocStickyHeader();
  initStickyHeaderEmu();
  initMobileMenuOffcanvas();

  // NOC Page Components Initialization
  initArchiveMasonry();
  initHeroSlider();
  initHeroBento();
  initCtaSlider();
  initCtaImageParallax();
  initCategoriesSlider();
  initArchiveShowcaseVideos();
  initArticleWSlider();

  // EMU Page Components Initialization
  initEmuHomeCarousel();

  // FAST Page Components Initialization
  initFastAutoSlider();

  // Post Components
  initVideoFacades();
  initGalleries();
  initAccordions();

  // Initialize Quicklink. It will automatically start listening for in-viewport links.
  listen();

  // Hydrate all React components found on the page
  hydrateComponents();

  // Reference 'store' in the log to satisfy the TypeScript "unused variable" check
  console.log(
    `[Main JS] Main JS bundle initialized. Store status: ${!!store ? "Active" : "Missing"}`,
  );
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGlobals);
} else {
  initGlobals();
}
